import { render, staticRenderFns } from "./BotPart.vue?vue&type=template&id=c0a36cf8&scoped=true"
import script from "./BotPart.vue?vue&type=script&lang=js"
export * from "./BotPart.vue?vue&type=script&lang=js"
import style0 from "./BotPart.vue?vue&type=style&index=0&id=c0a36cf8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0a36cf8",
  null
  
)

export default component.exports